// extracted by mini-css-extract-plugin
export default {"root":"AmbassadorLP_root__sjgM3"};